// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogEnXPirate = {
  "controls": {
    "boot": "Set Sail",
    "reset": "Mutiny!",
    "copyScreen": "Capture th' View",
    "copyText": "Plunder th' Text",
    "pasteText": "Stow th' Text",
    "saveState": "Stash Treasure",
    "restoreState": "Dig up th' Treasure",
    "toggleSound": "Toggle th' Squawkin'",
    "retrySound": "Squawkin' be unavailable, matey. Give 'er another go.",
    "settings": "Ship's Rigging",
    "debugPanel": "Debuggin' Deck",
    "infoPanel": "Info Chart",
    "reportIssue": "Report Scurvy Trouble",
    "privacyPolicy": "Articles o' Privacy"
  },
  "config": {
    "speed": "Ship's Gait",
    "display": "Spy th' Rigging",
    "theme": "Ship's Liv'ry",
    "openRetroControlPanel": "Control Deck",
    "resetSettings": "Reset All Rigging",
    "capsLock": "SHOUTIN' LOCK",
    "useOpenApple": "Harness {{modKey}} key fer Open Apple",
    "useShortcuts": "Harness {{modKey}} key fer Keyboard Shortcuts",
    "useArrowKeys": "Harness Arrow Keys fer Steerin' Stick",
    "scanlines": "Ghostly Scan Lines",
    "ghosting": "Phantom Glow",
    "crtDistortion": "Curvy Glass",
    "joystick": "Joystick Rigging"
  },
  "machine": {
    "configuration": "Machine Rigging",
    "slotConfigurator": "Cargo Holds",
    "models": {
      "apple2p": "Apple II+ (Ol' Reliable)",
      "apple2eu": "Apple IIe (Stock Timber)",
      "apple2ee": "Apple IIe (Fully Rigged)"
    },
    "ram": {
      "64kb_aux": "64 KB (Extra Cargo Hold)",
      "512kb": "512 KB (Mighty Hold)",
      "1024kb": "1024 KB (Big Hold)",
      "4mb": "4 MB (Treasure Trove)",
      "8mb": "8 MB (Captain's Hold)"
    }
  },
  "speed": {
    "snail": "Barnacle Speed (0.1 MHz)",
    "slow": "Turtle Speed (0.5 MHz)",
    "normal": "Sailin' Speed (1 MHz)",
    "two": "Fair Wind (2 MHz)",
    "three": "Strong Gale (3 MHz)",
    "fast": "Full Sail (4 MHz)",
    "warp": "Kraken Speed"
  },
  "colors": {
    "color": "Full Color",
    "nofringe": "Color (No Bleedin')",
    "green": "Seaweed Green",
    "amber": "Treasure Amber",
    "white": "Light o'er Dark",
    "inverse": "Dark o'er Light"
  },
  "themes": {
    "classic": "Olde Timey",
    "dark": "Dead of Night",
    "minimal": "Bare Bones"
  },
  "debug": {
    "helpPanel": "Signal SOS",
    "debugPanel": "Show debuggin' deck",
    "helpTab": "SOS",
    "debugTab": "Debuggin'",
    "basicTab": "Applesoft BOOTY",
    "expectinTab": "Anti-scurvy Jelly (exPectin)",
    "breakpoints": "Anchor Points",
    "memory": "Treasure Map",
    "stack": "Th' Stack",
    "state": "Brain Box State",
    "registers": "Ship's Counters",
    "flags": "Signal Flags",
    "step": "One Step",
    "stepOver": "Hop Over",
    "stepInto": "Dive Into",
    "stepOut": "Surface",
    "resume": "Carry On",
    "pause": "Drop Anchor",
    "loadSymbolTable": "Load th' Chart",
    "agentTab": "First Mate",
    "disassembly": "Code Map",
    "breakOnce": "Stop once then cast it off",
    "basicLineNumber": "BOOTY Line Number:",
    "any": "Yer Choice"
  },
  "disassembly": {
    "memory": {
      "effectiveAddress": "Where'd It Go?: {{notation}}",
      "value": "Value: {{notation}}"
    },
    "keyboard": {
      "character": "Organ Key-Board: \"{{character}}\"",
      "strobeClear": "Organ Key strobe: CLEAR (MSB = 0)",
      "strobeSet": "Organ Key strobe: SET (MSB = 1)",
      "anyKeyDownClear": "Organ Key flag: CLEAR (MSB = 0)",
      "anyKeyDownSet": "Organ Key flag: SET (MSB = 1)",
      "clearStrobe": "Scrub Organ Key strobe"
    },
    "cassette": {
      "toggleOutput": "Throw spinnaker toggle",
      "sampleInput": "Sight yer spinnaker input",
      "sampleInputMirror": "Sight yer looking-glass spinnaker input"
    },
    "speaker": {
      "toggleOutput": "Toggle th' squawker"
    },
    "notice": {
      "emulatorIdentifier": "LEDGER: Apple2TS Letter of Marque: $CD",
      "noWriteEffect": "LEDGER: This order falls on deaf ears aboard {{machine}}",
      "multipleTriggers": "HEED: This order strikes the toggle pin many a time",
      "unknownWrite": "HEED: This order scrawls an uncharted script"
    },
    "rom": {
      "intCxOff": "Inboard $Cx ROM: OFF (MSB = 0)",
      "intCxOn": "Inboard $Cx ROM: ON (MSB = 1)",
      "internal": "Select internal ROM fer {{range}}",
      "slot": "Select slot ROM fer {{range}}"
    },
    "languageCard": {
      "useRamForReads": "Language Card: Use RAM fer reads",
      "useRomForReads": "Language Card: Use ROM fer reads"
    },
    "auxMemory": {
      "readMain": "Select main memory fer reads",
      "readAuxiliary": "Select auxiliary memory fer reads",
      "writeMain": "Select main memory fer writes",
      "writeAuxiliary": "Select auxiliary memory fer writes",
      "selectExpansionBank": "Select auxiliary expansion bank {{bank}} usin' {{addressing}} addressing",
      "altzpMain": "Select main zero page, stack, an' bank-switched RAM",
      "altzpAuxiliary": "Select auxiliary zero page, stack, an' bank-switched RAM",
      "altzpStatusMain": "Zero page, stack, an' bank-switched RAM: MAIN (MSB = 0)",
      "altzpStatusAuxiliary": "Zero page, stack, an' bank-switched RAM: AUXILIARY (MSB = 1)"
    },
    "displayMemory": {
      "page2Clear": "Select display page 1, or main display memory wit' 80STORE",
      "page2Set": "Select display page 2, or auxiliary display memory wit' 80STORE"
    },
    "annunciator": {
      "disable": "Silence bell {{number}}",
      "enable": "Ring bell {{number}}"
    },
    "laser128ex": {
      "disableDiskSlowdown": "Laser 128EX: Disable automatic 1 MHz slowdown fer port 7 disk access (write-once bit 5)",
      "enableDiskSlowdown": "Laser 128EX: Enable automatic 1 MHz slowdown fer port 7 disk access (write-once bit 5)"
    }
  },
  "tour": {
    "welcome": "Welcome to the Apple2TS emulator, matey!",
    "clickNext": "To learn more, press the Next button, matey.",
    "bootButton": "Click here to start the emulator, matey.",
    "resetButton": "Click here to Reset the Apple II an' either reboot or enter BASIC, matey.",
    "diskImages": "Choose one of the installed disk images, matey.",
    "floppyDisks": "Or click one of the floppy disk icons to load a disk image, matey.",
    "saveRestore": "Ye can save an' restore the complete state of the emulator usin' these buttons, matey.",
    "themeButton": "Click here to change the emulator UI theme, matey.",
    "endTour": "Ye have reached the end of the tour, matey.",
    "tourSelectorHint": "Click on the globe tour button to try one of the other tours, or press Finish to start usin' the emulator, matey.",
    "settingsWelcome": "Apple2TS has a full set of controls fer both the emulator an' the Apple II, matey.",
    "mainControls": "Here, ye can boot an' reset the Apple II, restore an' save the state, copy the screen, or paste text into the emulator, matey.",
    "snapshot": "At any point, ye can take a snapshot of the current emulator state, then go back in time to an earlier state, or fast forward again. Ye can also save the emulator state wit' all of the current snapshots, matey.",
    "pauseButton": "Ye can pause the emulator at any time, freezing the 6502 processor. This is useful fer pausing the action in a game, or entering the debugger, matey.",
    "debugButton": "Click on the bug to enter debug mode, where ye can see the internal state of the 6502 processor. Click again to go back to normal mode, matey.",
    "configButtons": "The bottom row of buttons controls the state of the Apple II, startin' wit' the emulator speed, the screen color, an' muting the sound, matey.",
    "keyboardButtons": "If the caps lock key is turned on, then all typed characters be UPPERCASE, matey.",
    "altArrowKeys": "The next key determines whether the {{modKey}} key is used fer keyboard shortcuts or the Apple II Open Apple key. The final key determines whether the arrow keys can be used as the Apple II joystick, matey.",
    "clearCookies": "Apple2TS automatically saves the current emulator rigging as browser cookies. Press this button to reset this rigging an' delete the cookies, matey.",
    "debugWelcome": "Apple2TS has a rich set of tools to analyze an' debug 6502 assembly code, matey.",
    "debugIcon": "Click on the Bug icon on the Info tabs to view the Debug panel, matey.",
    "debugPause": "Press the Pause button to pause or resume execution of the emulator, matey.",
    "debugControls": "Now that we have paused, we can step through the disassembled code usin' the Step Over, Into, an' Out buttons. We can also quickly jump to the current address of the Program Counter (PC), matey.",
    "debugDisassembly": "Here we see the disassembled code, wit' the hex addresses, the three-letter instruction, an' any values or addresses. If ye move yer mouse over a green value, a tooltip shall appear wit' the current value. Clicking on a blue address shall scroll to that location. Ye can also click in the left gutter to add or remove breakpoints, matey.",
    "debugInfo": "In the middle we have the Stack Dump an' a Memory Map. The Memory Map updates in real time an' shows ye which memory banks be currently active, matey.",
    "debugMemory": "The last section displays the Apple II memory. Ye can use the droplist to examine different portions of memory. If ye switch to one of the HGR pages, ye shall get a magnified view of the hires screen, tied to the memory locations. Ye can also search fer hex values or ASCII strings, an' save the memory to a file, matey.",
    "back": "Turn Back",
    "close": "Batten Down",
    "last": "Make Port",
    "next": "Ahead",
    "nextLabelWithProgress": "Ahead (Step {step} o' {steps})",
    "skip": "Batten Down",
    "guidedTour": "Captain's Tour",
    "mainLabel": "Captain's Tour: Main Deck",
    "settingsLabel": "Captain's Tour: Rigging",
    "debugLabel": "Captain's Tour: Debuggin'"
  },
  "disk": {
    "drive1": "Port Drive",
    "drive2": "Starboard Drive",
    "hardDisk": "Ironclad Disk",
    "eject": "Cast Out Disk",
    "insert": "Load Disk Aboard",
    "writeProtected": "Under Lock",
    "readWrite": "Open Fer Business",
    "empty": "Empty Hold",
    "loading": "Loadin'...",
    "selectDisk": "Choose a Disk Chart",
    "browse": "Search th' Seas",
    "internetArchive": "Davy Jones' Archive",
    "totalReplay": "Total Replay (Best Games)",
    "newReleases": "Fresh Plunder",
    "writeProtectDisk": "Lock th' Disk",
    "saveDiskToDevice": "Stash Disk",
    "saveDiskTo": "Stash Disk in",
    "saveDiskToMenu": "Stash Disk in >",
    "addToFavorites": "Add to Hoard",
    "downloadDisk": "Plunder th' Disk",
    "downloadWoz": "Plunder WOZ Disk Image",
    "downloadAndEjectDisk": "Plunder an' Eject Disk",
    "ejectDisk": "Cast Out Disk",
    "ejectAllDisks": "Cast Out All Disks",
    "saveDiskToOneDrive": "Stash Disk in OneDrive",
    "saveDiskToGoogleDrive": "Stash Disk in Google Drive",
    "loadDisk": "Load Disk Aboard",
    "loadAdditionalDisks": "Load More Disks Aboard...",
    "loadDiskFrom": "Load Disk from",
    "loadDiskFromMenu": "Load Disk from >",
    "loadDiskFromDevice": "Load Disk from Yer Device",
    "loadDiskFromDeviceReadOnly": "Load Disk from Device (Locked Down)",
    "loadDiskFromDeviceReadWrite": "Load Disk from Device (Editable)",
    "loadDiskFromInternetArchive": "Load from Davy Jones' Archive",
    "loadDiskFromDemoZoo": "Load from DemoZoo",
    "loadDiskFromOneDrive": "Load from OneDrive",
    "loadDiskFromGoogleDrive": "Load from Google Drive",
    "insertBlankDisk": "Load Blank Disk Aboard",
    "syncNow": "Sync Right Now",
    "modified": "changed",
    "diskDrivesAndDevices": "disk drives an' devices",
    "clickToLoadDiskImage": "Click to load disk(s) aboard",
    "downloadingDisk": "Plunderin' disk",
    "clickToRemoveFromDiskCollection": "Click to remove from disk hoard",
    "clickToAddToDiskCollection": "Click to add to disk hoard",
    "clickToViewDetails": "Click fer more info",
    "standbyDisks": "Standby Platters (Click to swap yer plunder)"
  },
  "help": {
    "title": "Apple2TS",
    "credit": "(c) {{year}} Chris Torrence and the Apple2TS crew",
    "keyboardShortcuts": "Key Commands",
    "shortcutsUnavailable": "{{keyMod}} emulator commands be unavailable while that key serves as Open Apple. Ctrl+0 through Ctrl+5 still choose the emulator's speed, arrr!",
    "diskContainers": "Compressed booty chests:",
    "multiDiskNotice": "Multi-platter swappin': Click a drive's badge to open the quick-swap menu. Multi-disk booty chests (.zip, .7z, .gz) load all platters at once into yer stack.",
    "mobileInstructions": "Fer mobile contraptions:",
    "tapScreen": "Tap the screen to show the keyboard, matey.",
    "arrowKeys": "Press the arrow keys, esc, or tab buttons to send those keys to the emulator, matey.",
    "ctrlKey": "To send a control character, press the ctrl button once. Then tap the screen to show the keyboard an' press the desired key. The ctrl button shall automatically be released, matey.",
    "ctrlLock": "To send multiple control characters, press the ctrl button twice to lock it on (indicated by a green dot). Then tap the screen to show the keyboard an' press the desired keys. Press the ctrl button again to release it, matey.",
    "appleKeys": "The open apple an' closed apple keys behave the same as the ctrl key, matey.",
    "openAppleKey": "Open Apple: press Left Alt/Option",
    "closedAppleKey": "Closed Apple: press Right Alt/Option",
    "joystickKeys": "Joystick Keys: Numpad 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "Fer the on-screen keyboard, to use CTRL or ESC keys,\ntouch key once to enable it then touch the desired letter key, matey.",
    "urlParametersBody": "Fer optional URL parameters, append them to the URL after a question mark (?) an' separate multiple parameters wit' an ampersand (&). Use # to specify the disk image. See the Link Builder dialog fer examples, matey.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay wit' debugging",
      "totalReplayChoplifter": "Total Replay, load Choplifter, embedded mode",
      "a2Desktop": "A2Desktop 2MG wit' fast speed an' color",
      "embeddedBasic": "Embedded Applesoft BASIC Program",
      "binaryHexAddress": "Binary File wit' Hex Address"
    }
  },
  "messages": {
    "loading": "Loadin'...",
    "error": "Arrr, Trouble!",
    "success": "Avast! Success!",
    "confirm": "Confirm Orders",
    "cancel": "Belay",
    "ok": "Aye",
    "on": "aye",
    "off": "nay",
    "confirmTheme": "Reload th' emulator an' apply this theme now, matey?",
    "confirmReset": "Reset all rigging to default, matey?",
    "fileNotFound": "Lost at sea, matey!",
    "invalidFile": "Cursed file format!",
    "diskInserted": "Disk loaded aboard!",
    "diskEjected": "Disk cast overboard!"
  },
  "keyboard": {
    "capsLock": "SHOUTIN' LOCK",
    "delete": "Walk th' Plank"
  },
  "audio": {
    "speaker": "Squawker",
    "mockingboard": "Music Box",
    "midi": "MIDI",
    "configuration": "Sound Rigging",
    "volume": "Loudness",
    "mute": "Silence",
    "waveform": "Wave Shape"
  },
  "print": {
    "printer": "Printin' Press",
    "print": "Print It",
    "clear": "Clear Deck",
    "save": "Save th' Pages",
    "dumpScreen": "Print What's On Screen",
    "dumpScreenInverse": "Print Screen (Backwards)",
    "sendToPrinter": "Send to th' Press",
    "tearOff": "Tear off Page an' Reset",
    "printerConfig": "Printer Rigging"
  },
  "device": {
    "machineConfiguration": "Machine Rigging",
    "mockingboardWaveform": "Music Box wave form"
  },
  "collection": {
    "showApple2TSCollection": "Show Apple2TS Hoard",
    "showNewReleases": "Show fresh plunder",
    "chooseDiskImage": "Disk Hoard",
    "diskCollection": "Disk hoard",
    "clickToShowDetails": "Click to show details fer",
    "clickToLoadDisk": "Click to load disk aboard",
    "diskIsNewRelease": "Fresh treasure, this be!",
    "diskIsApple2TSCollection": "Disk is part of the Apple2TS hoard",
    "diskIsInternetArchive": "Disk is from Davy Jones' Archive",
    "diskIsDemoZoo": "Disk is from DemoZoo",
    "clickToRemoveFromCollection": "Click to remove from disk hoard",
    "clickToKeepInCollection": "Click to keep in disk hoard",
    "clickToAddToCollection": "Click to add to disk hoard",
    "diskIsSyncedVia": "Disk synced via",
    "cloudAuthRequired": "sign in required",
    "signIn": "Come Aboard",
    "export": "Ship Out",
    "reportExportIssue": "Report trouble wit' export"
  },
  "debugControls": {
    "goBackInTime": "Turn Back th' Clock",
    "takeSnapshot": "Mark th' Moment",
    "goForwardInTime": "Move Ahead in Time",
    "saveStateWithSnapshots": "Save State wit' Snapshots",
    "resume": "Hoist Anchor",
    "pause": "Drop Anchor",
    "trace": "Follow th' Trail",
    "tracing": "Trackin'",
    "downloadTraceLog": "Download th' Log"
  },
  "fullscreen": {
    "fullScreen": "Crow's Nest View"
  },
  "internetArchive": {
    "searchPlaceholder": "Type th' name of a software title or click one o' th' categories above",
    "go": "SAIL!"
  },
  "demoZoo": {
    "searchPlaceholder": "Search DemoZoo (title, scallywag)...",
    "go": "SAIL!",
    "all": "All Hands",
    "previous": "Astern",
    "next": "Forward",
    "pageOf": "Page {{page}} o' {{pages}}",
    "noProductions": "No DemoZoo productions found, matey.",
    "youtubeOnly": "This production only has a YouTube link:",
    "externalOnly": "This production only has an external DemoZoo link:",
    "openInNewTab": "Open in New Porthole"
  },
  "basic": {
    "newProgram": "Fresh Code",
    "newProgramWarning": "This shall clear the current program. Ye shall lose any unsaved changes. Be ye sure, matey?",
    "runFromBeginning": "Run from th' Top",
    "break": "Stop!",
    "continueRunning": "Keep Runnin'",
    "stepProgram": "Step Carefully",
    "resumeOutput": "Keep Talkin'",
    "freezeOutput": "Hush Now",
    "importProgram": "Load Code Aboard...",
    "exportProgram": "Save Code Ashore...",
    "renumberProgram": "Recount th' Lines",
    "rebuildProgram": "Rebuild from Memory",
    "displaySettings": "Flying Colours",
    "capitalizeKeywords": "SHOUT Orders",
    "rebuildWarning": "This shall replace the current program wit' a version rebuilt from the Apple II memory. Ye shall lose any unsaved changes. Be ye sure, matey?"
  },
  "expectin": {
    "runScript": "Run th' Script",
    "stopScript": "Belay th' Script"
  },
  "saveDisassembly": {
    "title": "Save Code Map"
  },
  "gamepad": {
    "useArrowKeys": "Use Arrow Keys fer Steerin'",
    "reverseYAxis": "Reverse Y-Axis fer Joystick"
  },
  "traceSettings": {
    "title": "Trace Rigging",
    "numLines": "Number o' lines to keep:",
    "rangeWarning": "Must be between 100 an' 100000",
    "collapseLoops": "Find repeatin' lines an' collapse loops",
    "ignoreRegisters": "Ignore register values when findin' repeatin' lines",
    "settings": "Ship's Settings"
  },
  "keyboardControl": {
    "hideKeyboard": "Hide th' Keys",
    "showKeyboard": "Show th' Keys"
  },
  "linkBuilder": {
    "title": "Link Forger",
    "buttonTitle": "Link Forger",
    "userInterface": "Interface:",
    "colorMode": "Color:",
    "ramDiskSize": "RAM disk size (kb):",
    "emulatorSpeed": "Ship's speed:",
    "uiTheme": "Theme:",
    "showDebugTab": "Show debuggin' deck",
    "sound": "Squawkin'",
    "startupOptionsTab": "Startup Orders",
    "diskImageToLoad": "Disk to load on startup:",
    "customDiskUrl": "Custom disk URL:",
    "textToType": "Text to type after loadin' disk:",
    "enterTextPlaceholder": "Enter text or BASIC code here",
    "runBasicAfterLoading": "Run BASIC program after loadin'",
    "enterHexPlaceholder": "Enter hex code here, e.g. A9 01 8D 00 03",
    "runHexAfterLoading": "Run hex program after loadin'",
    "finalUrl": "Finished Link:",
    "tryIt": "Give It a Go",
    "reset": "Reset Ship",
    "close": "Batten Down",
    "gameModes": {
      "normal": "Normal Sailin'",
      "game": "Game Mode (clean deck)",
      "embed": "Embed (hidden rigging)"
    },
    "colorNames": {
      "color": "Full Color",
      "nofringe": "Color (no bleedin')",
      "green": "Seaweed Screen",
      "amber": "Treasure Amber Screen",
      "white": "Ghostly White Screen",
      "inverse": "Backwards White"
    },
    "speedNames": {
      "snail": "Barnacle Speed",
      "slow": "Turtle",
      "normal": "1 MHz (Sailin' speed)",
      "two": "2 MHz (Fair wind)",
      "three": "3 MHz (Strong gale)",
      "four": "4 MHz (Full sail)",
      "warp": "Kraken!"
    },
    "machines": {
      "enhanced": "Apple IIe (Upgraded)",
      "unenhanced": "Apple IIe (Original)",
      "apple2p": "Apple II+ (Ol' Reliable)"
    },
    "themes": {
      "classic": "Olde Timey",
      "dark": "Dead o' Night",
      "minimal": "Bare Bones"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Rig yer slot cards",
      "slot": "Slot {{slot}}:",
      "cardNone": "None (empty)"
    },
    "additionalDiskDrives": "Extra Platter Drives",
    "slot6Drive1": "Slot 6 Platter 1 (Floppy 1)",
    "slot6Drive2": "Slot 6 Platter 2 (Floppy 2)",
    "slot7Drive1": "Slot 7 Platter 1 (Hard Platter 1)",
    "slot7Drive2": "Slot 7 Platter 2 (Hard Platter 2)",
    "slot2Drive1": "Slot 2 Platter 1 (VERA SD)",
    "slot4Drive1": "Slot 4 Platter 1 (VERA SD)",
    "addAdditionalDisk": "Add extra platter for swappin'",
    "removeDisk": "Cast away this platter",
    "addAnotherDisk": "Add another platter",
    "diskPlaceholder": "Platter {num} parchment name (e.g. sideB.woz|Scenario Platter)"
  },
  "agent": {
    "tabTitle": "First Mate",
    "setupTitle": "🤖 AI First Mate Setup",
    "setupInstruction": "Click the gear icon below to configure yer AI assistant, matey.",
    "welcomeTitle": "Ahoy! Welcome to th' Apple II assistant! I can help ye wit':",
    "welcomeItem1": "Inspectin' CPU registers an' memory",
    "welcomeItem2": "Controllin' execution (boot, reset, step, breakpoints)",
    "welcomeItem3": "Loadin' programs an' managing disks",
    "welcomeItem4": "Debuggin' 6502 assembly code",
    "welcomeItem5": "Readin' screen content an' system state",
    "welcomePrompt": "Just ask me anything, matey!",
    "userRole": "Ye",
    "assistantRole": "🤖 First Mate",
    "inputPlaceholder": "Ask me anything about the Apple II emulator... (Press Enter to send, Shift+Enter fer new line)",
    "stop": "Belay",
    "send": "Send Orders",
    "changeConfiguration": "Change rigging",
    "processing": "Thinkin'...",
    "configTitle": "Configure AI First Mate",
    "provider": "Service:",
    "model": "Brain:",
    "apiKey": "Secret Key:",
    "save": "Stash",
    "clear": "Clear Deck",
    "storageWarning": "Yer API key is stored locally in yer browser an' never sent to apple2ts.com. Get yer {{provider}} API key at",
    "ollamaWarning": "Ollama runs locally on yer machine. Make sure ye have Ollama installed an' runnin'. Download from",
    "providerNotConfigured": "First Mate not configured - click th' gear to set up yer AI assistant",
    "providerConfigured": "Service: {{provider}} ({{model}})",
    "invalidKeyFormat": "Invalid API key format fer {{provider}}"
  },
  "startup": {
    "welcome": "Arrr! This be ye Apple2TS",
    "subtitle": "Emulatin' yer olde Apple II",
    "copyright": "(c) {{year}} Cap'n Torrence & scallawags",
    "diskCollections": "Click on the Disk Hoards icon\nto load a disk or game, matey!"
  },
  "retroControl": {
    "machine": "Contraption",
    "fullscreen": "Full Sail",
    "diskCollection": "Disks",
    "diskDrives": "Disk Holds",
    "display": "Spyglass",
    "monitorMode": "Spyglass Mode",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Shanties",
    "options": "Rigging",
    "skin": "Garb",
    "personalization": "Personalization",
    "text": "Scrawl",
    "background": "Backdrop",
    "border": "Rim",
    "iigsColor": {
      "black": "Coal Black",
      "red": "Blood Red",
      "darkBlue": "Deep Sea Blue",
      "purple": "Royal Purple",
      "darkGreen": "Dark Sea Green",
      "darkGray": "Storm Gray",
      "mediumBlue": "Ocean Blue",
      "lightBlue": "Sky Blue",
      "brown": "Timber Brown",
      "orange": "Sunset Orange",
      "lightGray": "Fog Gray",
      "pink": "Coral Pink",
      "lightGreen": "Seafoam Green",
      "yellow": "Gold Yellow",
      "aquamarine": "Aquamarine",
      "white": "Sail White"
    },
    "keyboard": "Keys",
    "joystick": "Helm Stick",
    "slots": "Berths",
    "devices": "Contraptions",
    "printerPort": "Printer Port",
    "modemPort": "Modem Port",
    "quit": "Abandon Ship",
    "apple2tsCollection": "Apple2TS Hoard",
    "newReleases": "Fresh Booty",
    "favorites": "Treasures",
    "exportDisksToHdv": "Export Disks to HDV",
    "noDiskDrivesAvailable": "No disk holds available",
    "select": "Choose",
    "open": "Open",
    "load": "Load",
    "go": "Sail!",
    "save": "Stow",
    "clipboard": "Copyin' Board",
    "cancelEsc": "Belay:Esc",
    "color": "Colour",
    "systemSpeed": "Ship's Gait",
    "other": "Other Booty",
    "timeMachine": "Snapshots",
    "ports": "Harbors",
    "language": "Tongue",
    "retroTheme": "Old-School",
    "lowercaseInput": "Lowercase scrawl",
    "openAppleKey": "Open Apple key",
    "sortOrder": "Sort",
    "card": {
      "empty": "Empty Hold",
      "mockingboard": "Mockin'board"
    }
  }
}
